import {
	appliedFiltersAtom,
	filterConfigsAtom,
} from '@pages/VendorsSearch/containers/FilterPills/atoms';
import { FacetMultiSelectFilter } from '@pages/VendorsSearch/containers/FilterPills/components/facet-multi-select-filter';
import { FacetSingleSelectFilter } from '@pages/VendorsSearch/containers/FilterPills/components/facet-single-select-filter';
import type { FacetMultiSelectFilterStrategy } from '@pages/VendorsSearch/containers/FilterPills/strategies/facet-multi-select-filter-strategy';
import type { FacetSingleSelectFilterStrategy } from '@pages/VendorsSearch/containers/FilterPills/strategies/facet-single-select-filter-strategy';
import type { PricingFilterStrategy } from '@pages/VendorsSearch/containers/FilterPills/strategies/pricing-filter-strategy';
import { useAtomValue } from 'jotai';
import React, { type FC, useMemo } from 'react';
import { StartingPriceFilterPill } from '../../components/StartingPriceFilter/starting-price-filter-pill';

export interface FilterPillCategoryProps {
	filterCategory: Search.FilterPillCategory;
}

const FilterPillCategory: FC<FilterPillCategoryProps> = (props) => {
	const { filterCategory } = props;
	const filterConfigs = useAtomValue(filterConfigsAtom);
	const filterConfig = useMemo(() => {
		return Object.values(filterConfigs).find(
			(fc) => fc.name === filterCategory,
		);
	}, [filterCategory, filterConfigs]);
	const appliedFilters = useAtomValue(appliedFiltersAtom);
	const appliedFilter = useMemo(() => {
		return appliedFilters.find(
			(f) => f.getData().config.id === filterConfig?.id,
		);
	}, [appliedFilters, filterConfig?.id]);

	switch (filterConfig?.type) {
		case 'facet-multi-select':
			return (
				<FacetMultiSelectFilter
					filterConfig={filterConfig}
					appliedFilter={appliedFilter as FacetMultiSelectFilterStrategy}
				/>
			);
		case 'facet-single-select':
			return (
				<FacetSingleSelectFilter
					filterConfig={filterConfig}
					appliedFilter={appliedFilter as FacetSingleSelectFilterStrategy}
				/>
			);
		case 'pricing':
			return (
				<StartingPriceFilterPill
					appliedFilter={appliedFilter as PricingFilterStrategy}
				/>
			);
		default:
			return null;
	}
};

export default FilterPillCategory;
